import Modal from "react-bootstrap/Modal";
import success from "../asset/images/confirmlogo.png";
import "../style/main.css";
import "../style/rightside.css";
import Loader from "./loader";
import currencyPairCheck from "utilities/currencyPairCheck";
import { formatMoney } from "utilities/formatMoney";

function ConfirmInvoice(props) {
  const closeModal = () => {
    var datashow = props.show;
    props.setshow(!datashow);
  };
  const sendInvoice = () => {
    props.handleSubmitInvoice();
  };

  return (
      <Modal
          show={props.show}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="border-0 "
          onHide={() => props.setshow(false)}
      >
          <Modal.Body
              style={{
                  borderRadius: "16px",
                  padding: "0px",
                  border: "none",
              }}
          >
              <div
                  style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                  }}
              >
                  <div
                      className=""
                      style={{
                          borderBottom: "1px solid #E7E9FB",
                          padding: "8px 24px 8px 24px",
                      }}
                  >
                      <span
                          className="material-icons"
                          style={{ color: "#667085" }}
                          onClick={closeModal}
                      >
                          close
                      </span>
                  </div>
                  <div style={{ padding: "8px 24px 8px 24px" }}>
                      <div
                          style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "32px",
                              marginBottom: "10px",
                          }}
                      >
                          <div
                              style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "24px",
                                  flexDirection: "column",
                                  alignItems: "center",
                              }}
                          >
                              <div>
                                  <img src={success} alt="" />
                              </div>

                              <div
                                  style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "8px",
                                  }}
                              >
                                  <div
                                      style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          flexDirection: "column",
                                          alignItems: "center",
                                      }}
                                  >
                                      <h3
                                          style={{
                                              color: "#101828",
                                              fontWeight: "700",
                                              lineHeight: "24.3px",
                                              fontSize: "18px",
                                              textAlign: "center",
                                          }}
                                      >
                                          {props?.isDraft ? "Confirm Draft" : "Confirm Invoice"}
                                      </h3>
                                      <p
                                          style={{
                                              textAlign: "center",
                                              color: "#667085",
                                              fontWeight: "500",
                                              letterSpacing: "2%",
                                              fontSize: "16px",
                                              lineHeight: "24px",
                                          }}
                                      >
                                          {props?.isDraft
                                              ? "Are you sure you want to save this invoice as draft"
                                              : `Send invoice for ${currencyPairCheck(
                                                    props?.currency
                                                )}
                                          ${formatMoney(props?.subtotal)}`}
                                      </p>
                                  </div>
                              </div>
                          </div>
                          <div
                              style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                              }}
                          >
                              {!props?.showPreview && (
                                  <button
                                      style={{
                                          background: "#EBE4FF",
                                          color: "#6F00FF",
                                          padding: "16px 24px 16px 24px",
                                          border: "none",
                                          outline: "none",
                                          borderRadius: "8px",
                                          fontWeight: "500",
                                      }}
                                      onClick={() => props.setshow(false)}
                                  >
                                      Preview
                                  </button>
                              )}

                              <button
                                  type="submit"
                                  onClick={sendInvoice}
                                  disabled={props.loader}
                                  style={{
                                      background: "#6F00FF",
                                      color: "#fff",
                                      padding: "16px 24px 16px 24px",
                                      fontWeight: "500",
                                      border: "none",
                                      outline: "none",
                                      borderRadius: "8px",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                  }}
                              >
                                  {props.loader ? (
                                      <Loader />
                                  ) : props?.isDraft ? (
                                      "Save invoice"
                                  ) : (
                                      "Send Invoice"
                                  )}
                              </button>
                          </div>
                      </div>
                  </div>
              </div>
          </Modal.Body>
      </Modal>
  );
}

export default ConfirmInvoice;
